function getClientProtocol() {
  if (typeof window === "undefined" || !window.location) {
    return "";
  }
  return window.location.protocol;
}

export function upgradeHttpImageUrlForProtocol(value, protocol = "") {
  if (typeof value !== "string" || protocol !== "https:") {
    return value;
  }

  return value.replace(/^http:\/\//i, "https://");
}

export function upgradeHttpImageUrl(value) {
  return upgradeHttpImageUrlForProtocol(value, getClientProtocol());
}

export function upgradeHttpImageFields(owner, fieldNames = []) {
  if (!owner || typeof owner !== "object") {
    return owner;
  }

  let nextOwner = owner;
  fieldNames.forEach((fieldName) => {
    const value = owner[fieldName];
    const nextValue = upgradeHttpImageUrl(value);
    if (nextValue !== value) {
      if (nextOwner === owner) nextOwner = { ...owner };
      nextOwner[fieldName] = nextValue;
    }
  });
  return nextOwner;
}

export function upgradeHttpImageUrlsInHtml(value) {
  if (typeof value !== "string" || getClientProtocol() !== "https:") {
    return value;
  }

  return value.replace(
    /(<(?:img|source|video)\b[^>]*\b(?:src|srcset|poster)\s*=\s*["'])([^"']*)(["'])/gi,
    (_, prefix, url, suffix) => `${prefix}${url.replace(/http:\/\//gi, "https://")}${suffix}`,
  );
}
